import React from 'react';

import { Box } from '@mui/material';
import {
  CartesianGrid,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';

import { globalTheme } from '../../../../../../shared/theme/theme';
import { ReviewStatisticsModel } from '../../models/review-statistics.model';
import { CustomYAxisTick } from '../../shared/components/custom-y-axis-tick/custom-y-axis-tick';
import { StatsFallbackComponent } from '../stats-fallback-component/stats-fallback-component';
import { CustomTooltipAvgRatingsChart } from './components/custom-tooltip-avg-ratings-chart';
import { mapStatsRatingDataToOvertimeChartModel } from './utils/mappings.util';

export const AvgRatingsChart = ({
  stats,
}: {
  stats: ReviewStatisticsModel | null;
}) => {
  const data = stats?.overtimeBreakDown.map(
    mapStatsRatingDataToOvertimeChartModel
  );

  return (
    <Box sx={{ ml: '-24px' }}>
      <ResponsiveContainer width="100%" height={253}>
        {data && data.length > 0 ? (
          <LineChart data={data}>
            <CartesianGrid horizontal={false} />
            <XAxis dataKey="month" style={{ fontSize: '12px' }} />
            <YAxis
              padding={{ top: 20, bottom: 20 }}
              domain={[1, 5]}
              ticks={[1, 2, 3, 4, 5]}
              axisLine={false}
              tickLine={false}
              tick={<CustomYAxisTick />}
            />
            <Tooltip
              content={<CustomTooltipAvgRatingsChart />}
              wrapperStyle={{
                border: 'none',
                boxShadow: 'none',
                outline: 'none',
              }}
              cursor={{
                stroke: globalTheme.palette.primary.main,
                strokeWidth: 2,
              }}
            />
            <Line
              type="linear"
              dataKey="rating"
              stroke={globalTheme.palette.primary.main}
              strokeWidth={3}
              dot={{
                r: 3,
                stroke: globalTheme.palette.primary.main,
                strokeWidth: 2,
                fill: globalTheme.palette.appWhite.main,
              }}
            />
          </LineChart>
        ) : (
          <StatsFallbackComponent />
        )}
      </ResponsiveContainer>
    </Box>
  );
};
